var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrain = function SvgTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeMiterlimit: 10,
    d: "m2.3 15 1.642-2.632m7.747-.01L13.672 15m-10.938-.873h10.3M2.645 7.855l-.2 2.632a1.75 1.75 0 0 0 1.745 1.886h7.593v.004a1.75 1.75 0 0 0 1.745-1.885l-.607-7.877A1.75 1.75 0 0 0 11.176 1H4.792a1.75 1.75 0 0 0-1.745 1.615zm0 0a.88.88 0 0 0 .878.92h8.927c.5 0 .896-.42.873-.92M2.967 3.651a.87.87 0 0 1 .873-.831h8.284c.466 0 .849.364.872.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.09 11.075a.49.49 0 1 0 0-.98.49.49 0 0 0 0 .98M10.918 11.075a.49.49 0 1 0 0-.98.49.49 0 0 0 0 .98"
  })));
};
export default SvgTrain;